
import React, {FC} from 'react';
import Button from 'components/Button';

import * as styles from './styles.module.scss';

type ChatHintProps = {
	send: (v: string) => void
	hints: string[]
}

export const ChatHints: FC<ChatHintProps> = ({send, hints}) => (
	<div className={styles.hints}>
		<span>
			Type a question or choose an option to start
		</span>
		{hints.map((h, i) => (
			<Button
				key={i}
				variant='chat-blue'
				onClick={() => send(h)}
			>
				{h}
			</Button>
		))}
	</div>
);
